
<div class="toolbar">
      <button nz-button nzType="primary" nzSize="small" (click)="foldall()" nz-tooltip nzTooltipTitle="{{'jsonEditor.foldAll' |translateTA}}">
            <nz-icon nzType="menu-fold" />
      </button>
      <button nz-button nzType="primary" nzSize="small" (click)="unfoldall()" nz-tooltip nzTooltipTitle="{{'jsonEditor.unFoldAll' |translateTA}}">
            <nz-icon nzType="menu-unfold" />
      </button>
      <button nz-button nzType="primary" nzSize="small" (click)="copy()" nz-tooltip nzTooltipTitle="{{'jsonEditor.copy' |translateTA}}">
            <nz-icon nzType="copy" />
      </button>
      <button nz-button nzType="primary" nzSize="small" (click)="download()" nz-tooltip nzTooltipTitle="{{'jsonEditor.download' |translateTA}}">
            <nz-icon nzType="download" />
      </button>
</div>
<div
      class="app-ace-editor"
      #editor
      [ngStyle]="{'height': height}"
></div>